import React from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";

const AboutUs = () => {
  return (
    <div>
      <Header />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-[#111315]" />
        <div className="absolute inset-0 -z-10 theme-hero-bg" />
        <div className="absolute inset-0 -z-10 theme-grid-overlay" />

        <div className="relative mx-auto max-w-7xl px-6 pb-14 pt-12 md:pt-20 lg:px-8 lg:pb-20">
          <div className="mx-auto max-w-3xl text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-white/5 px-4 py-2">
              <span className="h-2 w-2 rounded-full bg-amber-300" />
              <span className="text-sm font-medium text-stone-300">About Orbitpay Services</span>
            </div>
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl leading-tight">
              Reliable Utility Services for Modern Properties
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-stone-200/80">
              Orbitpay delivers trusted AC repair, electrical work, plumbing support, and annual
              maintenance solutions. We focus on quality workmanship, transparent pricing, and
              fast service response for homes and commercial sites.
            </p>
          </div>
        </div>
      </section>

      <section className="relative py-12 md:py-20">
        <div className="absolute inset-0 theme-light-section -z-10" />
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-3">
            {[
              {
                title: "Mission",
                text: "Keep utility systems safe, efficient, and dependable through professional service execution.",
              },
              {
                title: "Vision",
                text: "Become the most trusted urban service network for AC and utility maintenance.",
              },
              {
                title: "Commitment",
                text: "Verified technicians, clear communication, and on-time support in every visit.",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="rounded-xl border border-stone-300/30 bg-white p-6 shadow-sm"
              >
                <h3 className="text-xl font-bold text-stone-900">{item.title}</h3>
                <p className="mt-3 text-stone-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
